<template>
  <div class="d-flex align-items-center">
    <span v-if="value !== null">{{ value }}</span>
    <b-badge
      v-if="notEnough"
      variant="light-warning"
      class="d-flex align-items-center cursor-pointer"
      :class="badgeClass"
      v-b-tooltip.hover.auto.v-warning="badgeTitle"
    >
      <feather-icon
        icon="InfoIcon"
        :class="featherClass"
      ></feather-icon>
      <span v-if="badgeText">{{ badgeText }}</span>
    </b-badge>
  </div>
</template>

<script>

import { BBadge, VBTooltip } from 'bootstrap-vue'

export default {
  name: 'NotEnoughMaterialBadge',
  components: {
    BBadge
  },
  props: {
    value: {
      type: String,
      default: () => null
    },
    notEnough: Boolean,
    badgeClass: [String, Object],
    badgeTitle: String,
    badgeText: String,
    featherClass: String,
  },
  directives: {
    'b-tooltip': VBTooltip
  },
}
</script>
